import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import LineChart from './LineChart'

export default withToolbar(LineChart, {
  pdfExport: {
    title: chartTitles.must,
  },
  timeWindow: 7 * 12,
  childProps: {
    yMax: 6,
    type: 'must',
    yAxisLabel: 'MUST Score',
    title: chartTitles.must,
    subTitle: 'Malnutrition Universal Screening Tool',
  },
})
